import React from 'react'
import { Explination } from '@enkla-gui'

export default function Output({ label, value, type = 'text', cols = 'col', hidden = false, tip = false, currency = 'SEK', bg = '' }) {
	switch (type) {
		case 'currency':
			value = new Intl.NumberFormat('sv-SE', {
				style: 'currency',
				currency: currency,
				maximumFractionDigits: 2
			}).format(value)
			break
		default:
			break
	}
	if (hidden) return null
	return (
		<div class={`component_Output ${cols} output-${bg}`}>
			<div class='form-group'>
				<input value={value || ''} disabled class='form-control-input form-control' />
				<label class='label-control text'>
					{label} {tip && <Explination tip={tip} />}
				</label>
			</div>
		</div>
	)
}
